import React, { useEffect } from 'react';
import { Image, Space } from 'antd';
import { string } from 'prop-types';
import brandLogo from '../../../assets/images/brand-logo-light-no-tagline.png';
import { MenuOutlined } from '@ant-design/icons';
import { connect, useDispatch, useSelector } from 'react-redux';
import { closeDrawer } from '../../../redux/actions/ui';
import { getCurrentPageFromLocation } from '../../../utils/utils';
import { accessRules } from '../../../utils/accessRules';
import { useLocation } from 'react-router-dom';
import { getGlobalVars } from '../../../redux/actions/globalVars';
import { setSteps } from '../../../redux/actions/verificationSteps';
import { getItems } from '../../../api/globalVars';
import { getVerificationSteps } from '../../../api/verificationSteps';

const Branding = ({globalVars}) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    getLogoInfo();
  }, []);

  useEffect(() => {
    fetchVerificationSteps();
  }, []);

  const getLogoInfo = async () => {
    try {
      const result = await getItems();
      const data = result.data?.data;
      dispatch(getGlobalVars(data));
    } catch (error) {
      console.log(error)
    }
  };

  const fetchVerificationSteps = async () => {
    try {
      const result = await getVerificationSteps();
      const data = result.data?.data;
      dispatch(setSteps(data));
    } catch (error) {
      console.log(error)
    }
  }

  const role = useSelector(({auth}) => auth.role);

  const show = () => {
      dispatch(closeDrawer(true))
  }

  return (
    <Space direction="horizontal">
      {role && accessRules?.[role]?.[getCurrentPageFromLocation(pathname)]?.['searchSidebar'] ?
        <MenuOutlined onClick={show} /> :
        null
      }
      <Image
        src={globalVars.logo ? globalVars.logo : brandLogo}
        alt="Bechtel Logo"
        preview={false}
        width="200px"
        style={{ paddingTop: '30px' }}
      />
    </Space>
  )
}

const mapStateToProps = state => ({
  globalVars: state.globalVars.globalVars
});

Branding.propTypes = { width: string, height: string };

export default connect(mapStateToProps)(Branding);
